import MetaTags from "react-meta-tags"
import React, { useState, useEffect } from "react"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import { useHistory, withRouter, Link } from "react-router-dom"

import { getToken,IsModemAccess } from '../../helpers/helper';
import {del,post} from '../../helpers/api_helper';
import { POST_GET_ALL_USER_ROLE,DELETE_USER_ROLE,POST_UPDATE_STATUS } from '../../helpers/url_helper';
import { toast } from 'react-toastify';
import ReactDOM from 'react-dom';

import $ from 'jquery'; 
import "datatables.net-dt/js/dataTables.dataTables";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb"


const UserProfile = props => {
    let history = useHistory();
    const [user_role_id, SetUserRoleId] = useState(0);

    useEffect(() => {
        get_user_role();
    }, [])

    // get user role list
    const get_user_role = () => {
        $(document).ready(function () {
            $('#dataTableExample').DataTable({
                destroy: true,
                "bProcessing": true,
                "bServerSide": true,
                'searching': true,
                'stateSave': true,
                "scrollX": true,
                "sServerMethod": "POST",
                "sAjaxSource": POST_GET_ALL_USER_ROLE,
                "order": [[0, 'desc']],
                columnDefs: [{ orderable: false, targets: [3,4] }, { "targets": 0, "visible": false }],
                "fnServerData": function (sSource, aoData, fnCallback) {
                    $.ajax({
                        "dataType": 'json',
                        "type": "POST",
                        "url": sSource,
                        "data": aoData,
                        "success": fnCallback,
                        headers: { 'Authorization': getToken() },
                    });
                },
                "columns": [
                    { "data": "user_role_id" },
                    { "data": "role_name" },
                    { "data": "role_type" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            ReactDOM.render(<>
                                {data.role_status === 1 && <button onClick={UpdateStatus.bind(this,data.user_role_id,data.role_status)}  className="border-0 badge badge-success fs-6"  >Active</button>}
                                {data.role_status === 0 && <button onClick={UpdateStatus.bind(this,data.user_role_id,data.role_status)} className="border-0 badge badge-danger fs-6" >Deactive</button>}
                            </>, td)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            ReactDOM.render(<>
                                {IsModemAccess('use_role','edit') && <> {(data.role_type !== 2 && data.role_type !== 3) && <button className="btn btn-soft-info waves-effect waves-light p-1 mr-2" onClick={() => { history.push('/assign-module/' + data.user_role_id); }} ><i className="bx bx-font align-middle"></i></button>}
                                <button className="btn btn-soft-success waves-effect waves-light p-1 mr-2" onClick={() => { history.push('/edit-user-role/' + data.user_role_id); }} ><i className="bx bx-edit align-middle"></i></button></>}
                                {IsModemAccess('use_role','delete') && <button className="btn btn-soft-danger waves-effect waves-light p-1 mr-2" onClick={() => { SetUserRoleId(data.user_role_id); }} data-toggle="modal" data-target="#deleteModal" ><i className="bx bx-trash-alt align-middle"></i></button>}
                            </>, td)
                        }
                    },
                ]
            });
        });
    }

    // remove user role
    const remove_row = async() => {
        var res_data =  await del(DELETE_USER_ROLE+"?user_role_id="+user_role_id);
        if(res_data.status){
            toast(res_data.message);
            get_user_role();
        }else{
            toast.error(res_data.message);
        }
    }

    //UpdateStatus
    const UpdateStatus = async(role_id,status) => {
        if(!IsModemAccess('user','edit')){
            toast('Does not permission this module');
        }
        var res_data =  await post(POST_UPDATE_STATUS,{user_role_id:role_id,status:status});
        if(res_data.status){
            toast(res_data.message);
            get_user_role();
        }else{
            toast.error(res_data.message);
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>User Roles | Free Money Coins</title>
                </MetaTags>
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumb title="Dashboard" breadcrumbItem="User Roles" />

                    <Row>
                        <Col lg="6">
                            <Card>
                                <CardBody>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <h5>User Roles List</h5>
                                        </div>
                                        <div className="col-sm-6 text-end">
                                        {IsModemAccess('use_role','add') && <Link to="add-user-role" className="btn btn-primary btn-sm w-xs">+ Add</Link>}
                                        </div>
                                    </div>
                                    <hr/>
                                    <div className="mt-4 mb-5">
                                    {IsModemAccess('use_role','view') &&
                                        <table id="dataTableExample" className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <td>Id</td>
                                                    <td>Name</td>
                                                    <td>Code</td>
                                                    <td>Status</td>
                                                    <td>Action</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                
                                            </tbody>
                                        </table>}
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="modal fade" id="deleteModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Confirm Delete</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete this record?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">No</button>
                            <button onClick={remove_row.bind(this)} data-dismiss="modal" className="btn btn-primary">Yes</button>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>

    )
}

export default withRouter(UserProfile)
